import { InjectionToken } from '@angular/core';
import { FeatureFlagsConfig } from '@portal-front/feature-flags/core';

export const FF_SERVICE = new InjectionToken<FeatureFlagsConfig>('FF_SERVICE');
